import styles from "./ReportReviewButton.scss";
import PropTypes from "prop-types";
import React from "react";
import { useReportReviews } from "../reportReviews/useReportReviews";

const ReportReviewButton = ({ reviewId }) => {
  const { handleReportButtonClick, disabled, reportReviewText } =
    useReportReviews(reviewId);
  return (
    <div className={styles.reportReviewButtonContainer}>
      <button
        disabled={disabled}
        className={styles.reportReviewButton}
        onClick={handleReportButtonClick}
        data-testid="reportReviewButton"
      >
        {reportReviewText}
      </button>
    </div>
  );
};

ReportReviewButton.propTypes = {
  reviewId: PropTypes.string.isRequired,
};

export default ReportReviewButton;
